import { ItemView } from './common/CommonComponents';
import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';

const PhoneNumberView = () => {
  const { lang } = useLanguage(translations);
  const { user } = useAuth();

  const items = [
    {
      field: 'phoneNumber',
      value: user.phoneNumber,
    },
    {
      field: 'textMessagingApproved',
      value: user.textMessagingApproved === true ? lang('yes') : user.textMessagingApproved === false ? lang('no') : '',
    },
  ];

  return <ItemView items={items} />;
};

export default PhoneNumberView;
